import React from 'react';
import { connect } from 'react-redux';
import QueryClausesAccordion from './QueryClausesAccordion';
import { canEditCohort } from '../../helper';
import { uniqueDictionariesInClauses, findQuery } from '../../state/shared';
import { updateClausePanels } from '../actions';

const QueryClausesAccordions = ({
  code,
  category,
  className,
  dictionaries,
  canEdit,
  activeDictionaryCode,
  updatePanels,
  queryUUID,
}) => (
  dictionaries.map((dictionary, index) => (
    <QueryClausesAccordion
      className={className}
      key={`cohort_dictionaries_accordion_${dictionary.code}`}
      code={code}
      category={category}
      dictionaryCode={dictionary.code}
      canEdit={canEdit}
      active={activeDictionaryCode === dictionary.code}
      onClick={() => updatePanels(code, category, dictionary.code)}
      index={index}
      queryUUID={queryUUID}
    />
  ))
);

export const mapStateToProps = ({
  cohorts: {
    cohorts,
  },
  auth: {
    role,
  },
}, ownProps) => {
  const { cohort, query } = findQuery(cohorts, ownProps);

  return {
    dictionaries: uniqueDictionariesInClauses(query, true),
    activeDictionaryCode: query.activeDictionaryCode,
    canEdit: canEditCohort(cohort, role),
  };
};

export const mapDispatchToProps = {
  updatePanels: updateClausePanels,
};

export default connect(mapStateToProps, mapDispatchToProps)(QueryClausesAccordions);
